<template>
    <div class="side-block-title">
        <slot></slot>
        {{name}}
    </div>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
    props:['name'],
})
</script>

<style lang="scss">
@import '@/scss/_variables.scss';
.side-block-title {
    border-bottom:0.5px solid #eee;
    height:47px;
    line-height: 39px;
    padding:0 15px;
    font-size: 16px;
    .get-more {
        float:right;
        line-height: 39px;
        color:#999;
        font-size: 15px;
    }
}
</style>